import { create } from 'zustand';

interface SchedulerStateShape {
  /** Job ids currently being executed by a runner. */
  runningJobIds: ReadonlySet<string>;
  setRunning: (ids: ReadonlySet<string>) => void;
}

export const useSchedulerState = create<SchedulerStateShape>((set) => ({
  runningJobIds: new Set<string>(),
  setRunning: (ids) => set({ runningJobIds: ids }),
}));

export function useRunningCount(): number {
  return useSchedulerState((s) => s.runningJobIds.size);
}

export function useIsJobRunning(jobId: string): boolean {
  return useSchedulerState((s) => s.runningJobIds.has(jobId));
}
